import { httpGet, httpPost, httpPatchMerge, httpDelete } from './../http'
import type { TEntityId } from '~/types/models'
import type { ISubindustry } from '~/types/industry/models'

const apiEntityPath = '/api/subindustries'

export async function getSubindustries() {
  const callingMn = getSubindustries.name
  const apiPath = `${apiEntityPath}`
  return httpGet<ISubindustry[]>({ callingMn, apiPath })
}

export async function createSubindustry(entity: ISubindustry) {
  const callingMn = createSubindustry.name
  const apiPath = apiEntityPath
  return httpPost<ISubindustry>({ callingMn, apiPath, entity })
}

export async function updateSubindustry(
  entityData: Partial<ISubindustry>,
  id: TEntityId
) {
  const callingMn = updateSubindustry.name
  const apiPath = `${apiEntityPath}/${id}`
  type TPartialSubindustry = Partial<ISubindustry>
  return httpPatchMerge<TPartialSubindustry>({
    callingMn,
    apiPath,
    entityData,
  })
}

export async function deleteSubindustry(entityData: ISubindustry) {
  const callingMn = deleteSubindustry.name
  const apiPath = apiEntityPath
  return httpDelete({
    callingMn,
    apiPath,
    entityData,
  })
}
